import { useGrowthBookFeature } from '@helloworld1812/ws-growthbook';

import type { FeatureId } from '@/helpers/growthbook/index';

export function useIsFeatureOn(featureId: FeatureId) {
  return useGrowthBookFeature<FeatureId>(featureId).on;
}
